import { apiRequest } from './http';

export interface RegionHint {
  countryCode: string | null;
  country: string | null;
  displayName: string | null;
}

const unknown: RegionHint = { countryCode: null, country: null, displayName: null };

let pending: Promise<RegionHint> | undefined;

/** ISO 3166-1 alpha-2 code -> flag emoji (regional indicator symbols); '' if not a 2-letter code. */
export function countryFlag(countryCode: string | null): string {
  if (!countryCode || !/^[A-Za-z]{2}$/.test(countryCode)) return '';
  return [...countryCode.toUpperCase()]
    .map((letter) => String.fromCodePoint(0x1f1e6 + letter.charCodeAt(0) - 65))
    .join('');
}

/**
 * The signed-in user's country, from their Entra `usageLocation`. A hint used to
 * pre-select filters and defaults, so a failure resolves to nulls rather than
 * throwing. Shared across callers: several pickers on one step must not each
 * ask the API.
 */
export function getMyRegionHint(): Promise<RegionHint> {
  pending ??= apiRequest<RegionHint>('/api/me/region-hint').catch(() => unknown);
  return pending;
}
